import { _beginformState as _beginformStorage } from '../_states/_beginformState';
import { _aboutyouState as _aboutyouStorage } from '../_states/_aboutyouState';
import { _detailState as _detailStorage } from '../_states/_detailState';
import { _reasonForReferralState as _reasonForReferralStorage } from '../_states/_reasonForReferralState';

export const _resetState = (function () {
    let isResetState = false;

    const getResetState = function () { return isResetState; };
    const setResetState = function (isReset) { isResetState = isReset; };

    const resetAllStates = function () {
      if (_resetState.getResetState()) {
        _beginformStorage.resetBeginFormState();
        _aboutyouStorage.resetAboutyouState();
        _detailStorage.resetDetailState();
        _reasonForReferralStorage.resetReasonState();
      }
    };

    return{
        getResetState: getResetState,
        setResetState: setResetState,
        resetAllStates: resetAllStates
    }
})();